import React, { Token, useEffect, useState } from 'react'

import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { getUsers } from '../../services/dataService';


  const DevRecipientSelection = ({handleUserSelected, returnUrl}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [lookupType, setLookupType] = useState("User");

  const handleSearch = async (query) => {
    setIsLoading(true);

  const items = await getUsers(query, lookupType);

  const options = items.map((i) => ({
          label: i.label,
          userName: i.userName,
        }));

        setOptions(options);
        setIsLoading(false);
  };
  
  const handleChange = (value) => {
        setIsLoading(false);
        handleUserSelected(value, returnUrl);    
  };

  let focusControl = null;
  useEffect(()=>{
    focusControl.focus();
  })

  const buildPlaceholderText = ()=>{
    switch (lookupType) {
      case "Carrier":
        return "Search by carrier name"
      case "Employer":
          return "Search by employer name"
      case "User":
          return "Search for a users email address"
    }
  }

  return (
    <div>
      <label  className="login-dev-label" >
      <input type="radio" name="userType" value="Carrier"  onClick={()=>setLookupType("Carrier")} checked={lookupType==="Carrier"}/> 
      Carrier
    </label>
    <label  className="login-dev-label">
      <input type="radio" name="userType" value="Employer"  onClick={()=>setLookupType("Employer")} checked={lookupType==="Employer"}/> 
      Employer
    </label>
    <label  className="login-dev-label">
      <input type="radio" name="userType" value="User"  onClick={()=>setLookupType("User")} checked={lookupType==="User"}/> 
      User
    </label>

    <AsyncTypeahead
      className= "fadeIn first" 
      id="search"
      ref={(ctl) => { focusControl = ctl; }}
      isLoading={isLoading}
      labelKey={(option) => `${option.label}`}
      minLength={3}
      onSearch={handleSearch}
      onChange={(value)=>handleChange(value[0])}
      useCache={false}
      options={options}
      placeholder = {buildPlaceholderText()}
      renderToken ={ (option,  index) => (
        <Token
          key={index}/>
      )}

    />
    </div>
  );
};

export default DevRecipientSelection;